export const GET_D2D_PILLS = 'GET_D2D_PILLS';
export const GET_D2D_PILLS_DONE = 'GET_D2D_PILLS_DONE';
export const GET_D2D_PILLS_ERR = 'GET_D2D_PILLS_ERR';
export const RESET_PILLS = 'RESET_PILLS';
export const SOFT_RESET_PILLS = 'SOFT_RESET_PILL';
//# sourceMappingURL=actionTypes.js.map